import React from 'react';
import PropTypes from 'prop-types';

class Pdfview extends React.Component { 
  render() {
    let styled = {
        width:'100%',
        padding:'15px 1.9%',
        minHeight:'500px'
    } 
    let pdf_files='https://www.361dm.com/announcementpdf/index.html?type=pdf#'+this.props.pdfpath;  
    
      return (
         <div key="pdf_files" className="border-bo">
        <div className="title-box">
          <div className="" title=""></div>
          <h2>{this.props.title}</h2>
        </div>
        
        <iframe className="announcement" src={pdf_files} style={styled}></iframe>
        </div> 
    );
  }
}
export default Pdfview;



// WEBPACK FOOTER //
// ./src/components/Pdfview.js